import { render, staticRenderFns } from "./orgUserList.vue?vue&type=template&id=68138f7c&scoped=true&"
import script from "./orgUserList.vue?vue&type=script&lang=js&"
export * from "./orgUserList.vue?vue&type=script&lang=js&"
import style0 from "./orgUserList.vue?vue&type=style&index=0&id=68138f7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68138f7c",
  null
  
)

export default component.exports